import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../ui/Button';
import ConsentPreferencesModal from './ConsentPreferencesModal';
import { useConsent, useConsentPreferencesOpener } from './consentClient';

/**
 * Bottom cookie-consent banner, shown until the visitor makes a choice.
 * The preference-center modal it opens stays reachable afterward too, via
 * the footer's "Consent Preferences" button calling
 * window.__consent.openPreferences() (see consentClient.js).
 */
const ConsentBanner = () => {
  const { consent, hasDecision, setConsent } = useConsent();
  const [preferencesOpen, setPreferencesOpen] = useState(false);

  useConsentPreferencesOpener(() => setPreferencesOpen(true));

  const acceptAll = () => {
    setConsent({ analytics: true, advertising: true });
    setPreferencesOpen(false);
  };
  const rejectAll = () => {
    setConsent({ analytics: false, advertising: false });
    setPreferencesOpen(false);
  };
  const savePreferences = (choices) => {
    setConsent(choices);
    setPreferencesOpen(false);
  };

  return (
    <>
      {!hasDecision && (
        <div
          role="region"
          aria-label="Cookie consent"
          className="fixed inset-x-0 bottom-0 z-[100] bg-brand-paper border-t border-brand-rose/25 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] px-5 py-4 sm:px-8"
        >
          <div className="mx-auto max-w-[1240px] flex flex-col sm:flex-row items-center gap-4">
            <p className="text-body text-secondary flex-1">
              We use cookies to keep you signed in and, with your permission,
              to understand how the site is used. See our{' '}
              <Link to="/privacy/cookie-policy" className="text-brand-400 underline hover:no-underline">Cookie Policy</Link>.
            </p>
            <div className="flex flex-wrap gap-2 justify-center">
              <Button type="button" variant="ghost" size="sm" onClick={rejectAll}>Reject all</Button>
              <Button type="button" variant="ghost" size="sm" onClick={() => setPreferencesOpen(true)}>Customise</Button>
              <Button type="button" variant="primary" size="sm" onClick={acceptAll}>Accept all</Button>
            </div>
          </div>
        </div>
      )}
      <ConsentPreferencesModal
        open={preferencesOpen}
        currentConsent={consent}
        onClose={() => setPreferencesOpen(false)}
        onSave={savePreferences}
        onAcceptAll={acceptAll}
        onRejectAll={rejectAll}
      />
    </>
  );
};

export default ConsentBanner;
